import { signOut } from "../../../stores/AuthSlice";
import { useAdminDispatch } from "../../../stores/AdminStore";
import { useMsal } from "@azure/msal-react";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useLocalStorage } from "@unleashed/hooks/useLocalStorage";

export const SignOut = () => {
  const dispatch = useAdminDispatch();
  const {instance} = useMsal();
  const [params] = useSearchParams();
  const storage = useLocalStorage();

  useEffect(() => {
    storage.remove(`${import.meta.env.MODE}_last_active_date`);
    instance.logoutRedirect({
      postLogoutRedirectUri: params.get("from")
    }).then(() => dispatch(signOut()));
  }, [dispatch, instance, params, storage]);

  return null;
};
